import { oneOf, string } from 'prop-types';
import React from 'react';

import { OPERATIVE_SYSTEM_TYPES } from '../../../products/constants';
import CampaignPushButton from '../../CampaignPushButton';

export default function CampaignLinePushButton({ type, ...rest }) {
  if (!type) {
    return null;
  }
  return (
    <CampaignPushButton
      type={type}
      className="c-campaign-line-btn rounded shadow btn-white-outline"
      {...rest}
    />
  );
}

CampaignLinePushButton.propTypes = {
  type: oneOf(Object.keys(OPERATIVE_SYSTEM_TYPES)),
  productCode: string,
};

CampaignLinePushButton.defaultProps = {
  type: undefined,
  productCode: undefined,
};
